import {
  LoginFormPage,
  ProConfigProvider,
} from '@ant-design/pro-components';
import { notification, Tabs, Form, Input } from 'antd';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useIsAuthenticated } from '@azure/msal-react';

type LoginType = 'account' | 'sso';




const Login = () => {

  const baseURL = process.env.REACT_APP_API_URL;
  const [loginType, setLoginType] = useState<LoginType>('account');
  const [username, setName] = useState("");
  const [pwd, setPassword] = useState("");
  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticated()

  useEffect(() => {

  }, [])


  const items = [
    { label: 'Username', key: 'account' },
    { label: 'Single Sign On', key: 'sso' }
  ]


  const validate = () => {
    let result = true;
    if (username == null || username === "") {
      result = false;
    }
    if (pwd === null || pwd === "") {
      result = false;
    }
    return result;

  }

  interface LoginFormValues {
    username: string;
    password: string;
  }

  const handleSubmitter = async (values: LoginFormValues) => {
    if (loginType === 'sso') {
      if (isAuthenticated) {
        navigate('/awards');
      }
      else {
        return;
      }

    }
    if (loginType === 'account') {
      if (validate()) {
        try {
          let inputobj = { username, pwd };
          const response = await axios.post(`${baseURL}/api/Authorize/login`, inputobj);
          if (response.status === 200) {
            // sessionStorage.setItem('token', response.data.token);
            notification.success({
              message: 'Login Successful',
              description: 'You have successfully logged in to the Talent Management Portal',

            });
            navigate('/admindashboard');
          }
        }
        catch (error: any) {
          if (error.response.status === 404) {
            notification.error({
              message: 'User Not Found',
              description: 'Inavlid Crdentials',
            });
          }
          else {
            notification.error({
              message: 'Error',
              description: 'An error occured while trying to login',
            });
          }
        }
      }

    }
  };


  const onFinishFailed = (errorInfo: any) => {

  };


  return (
    <div
      style={{
        backgroundColor: 'white',
        height: '100vh',
      }}
    >
      <LoginFormPage
        logo="favicon.ico"
        backgroundVideoUrl="https://gw.alipayobjects.com/v/huamei_gcee1x/afts/video/jXRBRK_VAwoAAAAAAAAAAAAAK4eUAQBr"
        title="Login"
        containerStyle={{
          backgroundColor: 'rgba(0, 0, 0,0.65)',
          backdropFilter: 'blur(4px)',
        }}
        submitter={{
          searchConfig: {
            submitText: 'Login',
          },
        }}
        initialValues={{
          remember: true,
        }}
        onFinish={handleSubmitter}
        onFinishFailed={onFinishFailed}
        autoComplete='off'
        subTitle="Aptean Talent Management Portal"

      >

        <Tabs items={items} centered activeKey={loginType} onChange={(key) => setLoginType(key as LoginType)} />


        {loginType === 'account' && (
          <>

            <Form.Item className='loginFormTitle'
              label={<text style={{ color: "white", }}><strong>Username</strong></text>}
              name="username"
              style={{
                color: 'white',

              }}
              rules={[
                {
                  required: true,
                  message: 'Please input your username!',
                },
              ]}
            >
              <Input value={username} onChange={e => setName(e.target.value)} />
            </Form.Item>

            <Form.Item
              label={<text style={{ color: "white", }}><strong>Password</strong></text>}
              name="password"
              rules={[
                {
                  required: true,
                  message: 'Please input your password!',
                },
              ]}
            >
              <Input.Password value={pwd} onChange={e => setPassword(e.target.value)} />
            </Form.Item>
          </>
        )}

        <div
          style={{
            marginBlockEnd: 24,
          }}
        >
        </div>
      </LoginFormPage>
    </div >
  );
};

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  return (
    <ProConfigProvider dark>
      <Login />
    </ProConfigProvider>
  );
};